<template>
  <div>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <van-cell v-for="(item, index) in buyCardList" :key="index" >
        <p>号码：{{ recordLoginText }}</p>
        <p>姓名：{{ item.takeNickname }}</p>
        <p>手机号：{{ item.takePhone }}</p>
        <p>创建时间：{{ item.createTime }}</p>
        <p>新iccid：{{ item.newIccid }}</p>
        <p>卡类型：{{ item.changeCmccSimName }}</p>
        <p>状态：{{ item.disposeState == 1 ? '待发货' : item.disposeState == 2 ? '拒绝' : '已发货'}}</p>
        <p>备注：{{ item.disposeRemark }}</p>
      </van-cell>
    </van-list>
  </div>
</template>

<script>
import { wxRequest } from '@/api/user.js' 
export default {
  data(){
    return {
      disposeState: '',
      oldIccid: this.$store.state.iccid,
      buyCardList: [],
      loading: false,
      finished: true,
      recordLoginText: localStorage.getItem('recordLoginText')
    }
  },
  methods: {
    onLoad(){

    },
    getQuestionList(){
      let data = {
        disposeState: this.disposeState,
        oldIccid: this.oldIccid
      }
      wxRequest('applyChangeSim/buy/iccid/list', data, 'post').then(res => {
        if(res.data.code == 200){
          this.buyCardList = res.data.data.resultList;
        }
      })
    }
  },
  watch:{
      '$route': function(to, from){
          this.disposeState = to.query.disposeState;
          this.getQuestionList();
      }
  },
  created(){
    this.disposeState = this.$route.query.disposeState;
    this.getQuestionList();
  }
}
</script>

<style>

</style>